var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Radio, Spinner, Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import { findLabelByLanguageCode, } from 'app/utils/supportedLanguages';
import styles from './satisfactionDropdown.module.scss';
const BUTTON_TEXT_BY_ASYNC_STATUS = {
    loading: 'Cancelling...',
    succeeded: 'Cancel CSAT',
    failed: 'Error',
};
export class SatisfactionDropdown extends React.Component {
    handleOnCancelClick() {
        const { toggleDropdown, onCancel } = this.props;
        onCancel();
        toggleDropdown();
    }
    handleLanguageSelection(languageCode) {
        const { toggleDropdown, onChange } = this.props;
        onChange(languageCode);
        toggleDropdown();
    }
    renderLanguage(languageCode) {
        const { selected } = this.props;
        const id = `satisfaction-dropdown-${languageCode}`;
        const label = findLabelByLanguageCode(languageCode);
        return (_jsxs("div", Object.assign({ className: styles.language }, { children: [_jsx("div", { children: _jsx(Radio, { className: styles.languageRadio, id: id, name: "satisfaction-language", checked: languageCode === selected, onChange: () => this.handleLanguageSelection(languageCode) }) }), _jsx(Tooltip, Object.assign({ content: label, dark: true }, { children: _jsx("label", Object.assign({ htmlFor: id, className: styles.languageCode }, { children: languageCode })) }))] }), id));
    }
    renderLanguages() {
        const { languageCodes, languageCodesAsyncStatus } = this.props;
        if (languageCodesAsyncStatus === 'loading') {
            return (_jsx("div", Object.assign({ className: styles.loading }, { children: _jsx(Spinner, { size: 16 }) })));
        }
        if (languageCodesAsyncStatus === 'succeeded') {
            return languageCodes.map(this.renderLanguage);
        }
        return null;
    }
    renderCancelButton() {
        const { cancelAsyncStatus } = this.props;
        const isLoading = cancelAsyncStatus === 'loading';
        const disabled = cancelAsyncStatus !== 'succeeded';
        const text = BUTTON_TEXT_BY_ASYNC_STATUS[cancelAsyncStatus];
        const variant = cancelAsyncStatus === 'failed' ? 'danger' : 'secondary';
        return (_jsx(Button, Object.assign({ isLoading: isLoading, disabled: disabled, variant: variant, onClick: this.handleOnCancelClick }, { children: text })));
    }
    render() {
        const { isCancellable } = this.props;
        return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", Object.assign({ className: styles.languagesWrapper }, { children: _jsx("div", Object.assign({ className: styles.languages }, { children: this.renderLanguages() })) })), isCancellable && _jsx("div", { children: this.renderCancelButton() })] })));
    }
}
__decorate([
    boundMethod
], SatisfactionDropdown.prototype, "handleOnCancelClick", null);
__decorate([
    boundMethod
], SatisfactionDropdown.prototype, "handleLanguageSelection", null);
__decorate([
    boundMethod
], SatisfactionDropdown.prototype, "renderLanguage", null);
